export const CheckList = ({ items }: { items: readonly string[] }) => (
  <ul className="landing-check-list">
    {items.map((item) => (
      <li key={item}>
        <span aria-hidden="true" className="landing-check">
          ✓
        </span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);
